<template>
  <transition name="fade" mode="out-in">
    <div id="sherpaCrmApp" :class="['wrapper', 'w3-row', currentContentId]">
      <sherpa-dialog ref="dialog" />
      <div :class="['sherpaCrmAppLoading', {'visible': appLoading}]">
        <spinner-loading :size="40" :line-size='2' line-fg-color='#5dbecd' />
      </div>
      <div id="sidebar-login" :class="{'w3-third':!isAuthenticated, 'logged':isAuthenticated, 'rememberPassword':rememberPasswordMode}">
        <control-panel @rememberPassword="rememberPassword"/>
      </div>
      <div id="rest-pantalla" class="Rectangle" :style="noLoggedBackgroundImageStyle" :class="{'w3-twothird nologged': !isAuthenticated, 'w3-rest': isAuthenticated, 'closeMenu': !isControlPanelOpen}">
        <div v-if="!isAuthenticated" class="login-title">
          {{ $ml.get('appTitle') }}
        </div>
        <div v-if="!isAuthenticated" class="login-subtitle">
          {{ $ml.get('appSubtitle') }}
        </div>
        <div id="content" class="w3-main" :class="{'logged':isAuthenticated}">
          <app-header v-if="isAuthenticated" />
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
          <transition name="fade" mode="out-in">
            <span class="w3-display-topright go_back" v-if="isAuthenticated && !isDetailShown">
              <i class="fas fa-angle-left" @click="goBack()"></i>
            </span>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import AppHeader from '@/components/appHeader'
import ControlPanel from '@/components/controlPanel'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import * as controlPanelTypes from '@/store/actions/controlPanel'
import store from '@/store'
import { router } from '@/router'
import * as api from '@/utils/api'
import menu from '@/utils/menu'
import Configuration from '@/configuration'
import SherpaDialog from '@/components/shared/Dialog.vue'

export default {
  name: 'sherpa-crm-app',
  components: {
    AppHeader,
    ControlPanel,
    SherpaDialog
  },
  data () {
    return {
      rememberPasswordMode: false
    }
  },
  beforeCreate () {
    var vm = this
    window.onpopstate = function (hander) {
      vm.$router.replace(window.location.pathname)
    }
  },
  mounted () {
    // connect $dialog to Dialog component instance (global so all child components can use this.$dialog)
    this.$dialog = this.$refs.dialog
    this.$.appContext.app.config.globalProperties.$dialog = this.$refs.dialog

    // logout
    window.addEventListener('beforeunload', this.logout)

    // safety: show body after 8s in case initialization never completes
    setTimeout(() => { document.body.style.opacity = '1' }, 8000)

    // sessionExpiration
    setInterval(() => {
      const expiration = localStorage.getItem('sessionExpiration')
      if (expiration && Date.now() > parseInt(expiration)) {
        localStorage.removeItem('sessionExpiration')
        this.logout()
      }
    }, 5000) // cada 5 segundos
  },
  methods: {
    rememberPassword (rememberPassword) {
      this.rememberPasswordMode = rememberPassword
    },
    logout (event) {
      document.body.style.transition = 'none'
      document.body.style.opacity = '0'
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_LOGOUT}`, {removeToken: !Configuration.value('NORMAL_LOGIN')})
    },
    goBack () {
      this.$router.go(-1)
    },
    getQueryParam (paramName) {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get(paramName)
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`]),
    ...mapGetters(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}`, [`${controlPanelTypes.CONTROL_PANEL_IS_OPEN}`]),
    ...mapGetters(`${appTypes.APP_NAMESPACE}`, [`${appTypes.APP_CURRENT_CONTENT_ID}`]),
    ...mapGetters(`${appTypes.APP_NAMESPACE}`, [`${appTypes.APP_LOADING}`]),
    ...mapGetters(`${appTypes.APP_NAMESPACE}`, [`${appTypes.APP_INITIALIZED}`]),
    ...mapGetters(`${appTypes.APP_NAMESPACE}`, [`${appTypes.APP_DETAIL_SHOWN}`]),
    noLoggedBackgroundImageStyle () {
      if (!this.isAuthenticated) {
        return `background-image: url('${process.env.CONTEXT_PATH}static/bg.png')`
      }
    }
  },
  watch: {
    appInitialized (val) {
      if (val) {
        this.$nextTick(() => {
          document.body.style.transition = 'opacity 0.2s ease'
          document.body.style.opacity = '1'
        })
      }
    },
    $route (to, from) {
      if (to.matched.length > 0) {
        var item = to.matched[to.matched.length - 1].props.default
        if (item.type) {
          // 3: APP visible menu levels
          if (to.matched.length <= 3) {
            this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, item)
            document.getElementsByTagName('html')[0].style.overflowY = 'auto'
          } else {
            var parentItem = to.matched[2].props.default
            this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, parentItem)
          }
        }
      }
    }
  }
}

// tractar entrada a aplicació
router.beforeEach((to, from, next) => {
  if ((to.name === 'login' || to.name === 'root') && from.name !== null && from.name !== 'login') {
    store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_LOGOUT}`, {removeToken: !Configuration.value('NORMAL_LOGIN')})
  }

  // hide detail container on level 3 or low menu options
  if (to.matched.length < 4) {
    store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
  }

  if (to.matched.length > 0) {
    var toItem = to.matched[to.matched.length - 1].props.default
    if (toItem) {
      if (toItem.type) {
        store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)

        var splittedPath = to.matched[to.matched.length - 1].path.split('/')
        var numPathParams = splittedPath.length - 1
        var lastSplittedPath = splittedPath[splittedPath.length - 1]

        // no detail level
        if (to.matched.length <= 3 && to.matched.length === numPathParams) {
          var item = to.matched[to.matched.length - 1].props.default
          toItem.content = item

          if (to.hash === '') {
            next()
            store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
          }

        // detail level or third level width id (single file builders case)
        } else if (to.matched.length > 3 || to.matched.length < numPathParams) {
          var dataId = to.params.id
          // The id is setted by last path param
          if (!dataId && to.matched.length < numPathParams) {
            dataId = lastSplittedPath
          }

          // We go to Detail; open Detail Frame
          if (to.matched.length > 3) {
            store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, true)
          }
          var endpoint = toItem.type.endpoint
          var id = toItem.id
          var name = toItem.name
          api.call({access: api.ACCESS_SERVICES, url: endpoint, method: 'POST', data: { id: dataId }})
            .then(resp => {
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_CONTENT}`, {resp, endpoint: endpoint, id: id, name: name})
              toItem.content = resp
              if (to.hash === '') {
                next()
              }
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
            })
            .catch(err => {
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
              // open error service dialog
              store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, err)
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
            })
        }
      } else {
        var contentItem = null
        if (toItem.subMenu) {
          contentItem = menu.methods.getDefaultCurrentContent(toItem.subMenu)
        } else {
          contentItem = toItem
        }

        if (!contentItem && toItem.subMenu.length > 0) {
          contentItem = toItem.subMenu[0]
        }

        if (contentItem.parentContextPath + contentItem.contextPath !== from.fullPath) {
          store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
          router.push(contentItem.parentContextPath + contentItem.contextPath).catch(() => {})
        }
      }
    } else {
      if (to.hash === '') {
        next()
      }
    }
  }
})
</script>

<style src="@fortawesome/fontawesome-free/css/all.min.css"></style>
<style src="vue-definition-utils/dist/vue-multiselect.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>
<style src="element-ui/lib/theme-chalk/index.css"></style>

<style>
.v-popper--theme-tooltip .v-popper__inner {
  background: #d42e12 !important;
  color: #fff !important;
  font-size: 11px !important;
  padding: 4px 8px !important;
  border-radius: 3px !important;
}
.v-popper--theme-tooltip .v-popper__arrow-outer {
  border-color: #d42e12 !important;
}
.v-popper--theme-tooltip .v-popper__arrow-inner {
  border-color: #d42e12 !important;
}
</style>

<style lang="scss">
.sherpaCrmAppLoading {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(120,120,120,0.76);
  z-index: 1000000000000000;
  display: table;
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.3s, opacity 0.3s ease;

  > div {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  &.visible {
    visibility: visible;
    opacity: 1;
    transition: none;
  }
}

#sidebar-login {
  position: fixed;
  top: 0;
  bottom: 0;
  min-width: 440px;
  background-color: #fff;
  z-index: 1;
  transition: width 0.5s ease, min-width 0.5s ease;

  &.logged {
    min-width: 100px;
    width: 100px;
  }

  &.rememberPassword {
    background-color: #000;

    #footer-info {
      display: none;
    }
  }
}

.multiselect__content-wrapper {
  z-index: 100000000000000 !important;
  position: absolute !important;
  min-width: 100%;
}

div[data-gjs-type="mj-body"] {
  padding-bottom: 20px;
}

.gjs-toolbar, .gjs-badge {
  background-color: #d42e12 !important;
}

.gjs-cv-canvas .gjs-highlighter,
.gjs-cv-canvas .gjs-highlighter-sel {
  outline: 1px solid #d42e12 !important;
}

.gjs-rte-actionbar {
  .gjs-field {
    background-color: #fcfcfc;
  }
}

html, body,
#sherpaCrmApp {
  height: 100%;
  background-color: #fcfcfc;
  overflow: hidden !important;

  .w3-modal {
    background-color: transparent;
  }

  .w3-btn:hover {
    box-shadow: none;

    span {
      transition: all 0.2s ease-in;
      color: #000;
    }
  }

  .login-title {
    font-family: "Source Sans Pro", sans-serif;
    font-weight: 700;
    font-size: 75px;
    line-height: 1.3em;
    position: absolute;
    top: 37%;
    left: 45%;
    display: none;
  }
  .login-subtitle {
    font-family: "Source Sans Pro", sans-serif;
    font-weight: 300;
    font-size: 30px;
    line-height: 1.3em;
    position: absolute;
    top: 45%;
    left: 45%;
    font-style: italic;
    display: none;
  }
  #gjs {
    position: absolute;
    bottom: 0;
    top: 0;
    height: initial !important;
    border: 1px solid #666;
  }
  .gjs-one-bg {
    background-color: #333;
  }
  .gjs-pn-options {
    right: initial !important;
    left: 0;
  }
  .gjs-pn-buttons {
    display: block !important;
  }
  .gjs-am-preview-cont {
    background-color: transparent;
  }
  .gjs-pn-devices-c {
    right: 15%;
  }
  .gjs-pn-commands,
  .gjs-pn-views-container {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .gjs-pn-views {
    border-left: 1px solid rgba(0,0,0,0.2);
    text-align: left;
  }
  .gjs-pn-btn.gjs-pn-active {
    color: #d42e12;
  }
  .gjs-dashed {
    outline: 1px dashed rgba(200,200,200,0.7) !important;
    outline-offset: -3px !important;
  }
  #gjs {
    .fa {
      font-family: FontAwesome !important;
    }
  }
  .gjs-dashed #wrapper {
    outline: 0;
  }
  .gjs-block svg {
    width: 45%;
    min-width: 40px;
  }
  .gjs-fonts::before {
    font-size: 4em;
  }

  .gjs-field-arrow-d,
  .gjs-field .gjs-d-s-arrow {
    border-top: 4px solid rgba(150,150,150,1);
  }
  .gjs-editor-cont .sp-container button, .gjs-editor-cont .sp-container button:hover, .gjs-editor-cont .sp-container button:active {
    color: #d42e12;
  }
}
#rest-pantalla {
  height: 100%;

  &.nologged {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-color: #fafafa;
  }

  &.closeMenu {
    #content {
      &.logged {
        margin-left: 100px;
      }
    }
  }

  #content {
    height: 100%;
    overflow: hidden;
    position: relative;

    &.logged {
      top: 0;
      right: 0;
      width: auto;
      margin-left: 350px;
      transition: all 0.5s;
    }
    &.active {
      margin-left: 150px;
    }

    .app-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    > .app-container {
      padding: 0 !important;
      top: 89px !important;
      margin: 10px 12px 0 18px;
      overflow: auto;

      &#dashboard {
        margin: 0 12px 55px;
      }

      &::-webkit-scrollbar {
        width: 12px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 10px;
        border: 3px solid #f1f1f1;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
      }
    }
  }
}

.new-email-template,
.new-landing-template,
.new-certificate-template,
.new-minutes-template,
.new-announcement-template {
  #rest-pantalla {
    #content {
      background-color: #202020;

      #contenidor_appheader {
        display: none;
      }

      > .app-container {
        #container_form_definition.new {
          padding-bottom: 0;
        }

        > .container-simplebar {
          top: 0;
        }
      }
    }
  }
}

.search-email-template,
.search-landing-template,
.search-certificate-template,
.search-minutes-template,
.search-announcement-template,
.search-remember-template,
.search-hiring-template {
  #detail {
    top: 0;
    left: 100px;
    right: 0;
    background-color: #202020;

    .definition-title,
    .container_menu_detail {
      display: none;
    }

    .w3-modal-content {
      background-color: transparent;
    }

    >.w3-modal-content >.w3-container {
      [data-simplebar] {
        top: 0;
        left: 18px;
        right: 18px;
        width: initial;
      }
      .container_detail {
        margin-top: 0;
        padding-bottom: 0;
        background-color: transparent;
      }
    }
  }
}

.search-sending-email {
  #detail {
    >.w3-modal-content >.w3-container {
      .container_detail#get-sending-email-content {
        padding-bottom: 0;
      }
    }
  }
}

#get-sending-email-planning {
  #app_attremailsending_segmentgroup {
    position: fixed;
    top: 295px;
    bottom: 62px;
    right: 18px;
    left: 120px;
    width: initial;
    overflow: auto;

    .group-header {
      margin-bottom: 0;
    }

    #app_attremailsending_segmentperson {
      padding: 0 10px 5px 3px;

      .multiselect-wrapper {
        width: 300px;
        float: left;

        .multiselect__tags {
          max-height: 490px;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 1px 5px 0 8px !important;

          .multiselect__input {
            position: absolute;
            top: 45px !important;
            left: 0;
            padding-top: 3px;
            padding-bottom: 3px;

            &::placeholder {
              color: #d0d0d0;
              font-style: italic;
            }
          }
        }

        .multiselect__content-wrapper {
          position: absolute !important;
          top: 70px;
        }
      }

      .taskTree {
        position: absolute;
        left: 310px;
        right: 0;
        top: 2px;
        height: 490px;
        background-color: #fff;
        border: 1px solid #e8e8e8;

        .tree-container {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;

          .tree-controls {
            display: none;
          }

          .treeclass {
            margin-top: 0;
          }
        }
      }
    }
  }
}

#back_to_top {
  color: #ff7643;
}
.languages {
  /* display: none; */
  position: fixed;
  bottom: 10px;
  right: 0;
  left: 0;
  z-index: 99;
}

.home {
  .timeline {
    margin-top: 0 !important;
    --timelineTheme: #fff !important;

    .repeatable {
      margin-top: 0;
      padding-top: 0;
    }
  }
  .definitionObj {
    &.group {
      .timeline {
        margin: 0 10px;
      }
    }
  }
  .tree-container {
    top: 20px;

    .tree-controls {
      display: none;
    }

    .treeclass {
      margin-top: 10px;
    }
  }
}

.tooltip {
  display: block !important;
  z-index: 100000000;
  font-size: 14px !important;

  .tooltip-inner {
    background: #d42e12 !important;
    color: white;
    border-radius: 9px;
    padding: 5px 15px 5px;
    font-family: "Source Sans Pro", sans-serif !important;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #d42e12 !important;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 6px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

.simplebar-content-wrapper {
  border: 0;
  outline: none;
}

/* Dialog */
.sherpaDialog {
  .dg-content-cont--floating {
    top: 50%;
  }
  .dg-backdrop,
  .dg-container {
    z-index: 5000000;
  }
  .dg-backdrop {
    background-color: rgba(0, 0, 0, 0.4)
  }
  .dg-main-content {
    max-width: fit-content;
    border: 0;
    padding: 30px 40px;
    background-color: #000;
    border-radius: 0;
  }
  .dg-content {
    font-size: 18px;
    font-family: 'Noto Sans';
    color: #ffffff;
    text-align: center;
  }
  .dg-content-body {
    border-bottom: 1px dotted #efefef;
    min-height: 300px;
    display: flex;
    align-items: center;
  }
  .dg-btn {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 16px;
    border: 0;
    font-weight: 600;
    transition: all 0.2s ease-in;
    border-radius: 0;
  }
  .dg-btn:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
  }
  .dg-btn--cancel {
    background-color: #edf118;
    color: #000;
    margin-right: 10px;

    &:hover {
      color: #999;
    }
  }
  .dg-btn--ok {
    background-color: #d42e12;
    color: #fff;
    margin-left: 10px;

    &:hover {
      color: #000;
    }
  }
  &.sherpaDialogOnlyOk {
    .dg-btn--cancel {
      display: none;
    }
  }
}
.w3-col.w3-10 {
  width: 10%;
}
.w3-col.w3-20 {
  width: 20%;
}
.w3-col.w3-30 {
  width: 30%;
}
.w3-col.w3-40 {
  width: 40%;
}
.w3-col.w3-60 {
  width: 60%;
}
.w3-col.w3-70 {
  width: 70%;
}
.w3-col.w3-80 {
  width: 80%;
}
.w3-col.w3-90 {
  width: 90%;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}
.no-padding-bottom {
  padding-bottom: 0 !important;
}

.sendemail {
  .taskButton {
     .w3-buttonTask {
       padding: 30px 10px 0 10px;
     }
   }
 }
</style>

<style lang="scss">
.popup {
  .txtPopup {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 0.83;
    letter-spacing: normal;
    color: white;
  }

  div.definition-title {
    span:first-of-type {
      margin-left: 0;
      font-size: 14px;
      color: #ffffff;
      font-family: "Source Sans Pro", sans-serif !important;
      display: block;
    }
  }

  #container_form_definition {
    &.modify {
      > #form_definition {
        padding-bottom: 20px;
      }
    }
    .definitionObj {
      padding: 0px 5px 0;
    }
    .definition-wrapper.group {
      padding: 0;

      div.title {
        display: none;
      }
    }
    .headerLangTitle {
      color: #ffffff;
    }
    .label.error_validate {
      color: #E78587;
      margin-top: 9px;
    }
    .group.error_group_validate {
      border: 1px solid #E78587;
    }
  }

  #type_actions {
    position: relative;
    background-color: transparent;
    text-align: center;
    margin-top: 15px;

    .save-and-stay {
      display: none;
    }

    .formErrors,
    .formSaved {
      width: 100%;
      display: block;
      clear: both;
      margin: 10px auto 0;
    }

    .containerFormConfirmDelete {
      margin-right: 0;

      button {
        border-radius: 8px !important;
      }
      .formConfirmDelete {
        border-radius: 8px !important;
        width: 100%;
      }
    }
  }

  .w3-modal {
    display: block !important;
    padding: 50px 0;
    cursor: auto;
    z-index: 999;
    background: rgba(0,0,0,0.5) !important;

    .w3-modal-content {
      background-color: #1c5770;
      top: 25px;
      bottom: 25px;
      right: 25px;
      left: 25px;
      width: initial;
      position: fixed;

      &.definition-error {
        top: 225px;
        bottom: 225px;
        right: 225px;
        left: 325px;

        .popup-content {
          margin-top: 200px;
          text-align: center;
          color: #efefef;
          font-family: "Source Sans Pro", sans-serif;
          font-size: 20px;
          font-weight: 600;

          i.icon-ico_error {
            color: #df0000;
            vertical-align: sub;
            border-radius: 50%;
            font-size: 24px;
            margin-right: 4px;
          }
        }
      }

      [data-simplebar] {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
      }

      .popup-title {
        font-family: "Source Sans Pro", sans-serif;
        font-size: 28px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 0.83;
        letter-spacing: normal;
        color: white;
        margin: 45px;
      }

      .popup-content {
        margin: 45px;

        .definitionObj {
          .label, p {
            color: #6bceda;
            vertical-align: middle;
            margin-bottom: 2px;

            &.message {
              padding-top: 5px;
            }

            &.error {
              color: #f58686 !important;
            }
          }

          .count {
            color: #cfcfcf;
          }
        }

        p.italic {
          font-style: italic;
        }

        .input-date,
        .input-checkbox,
        .input-batches {
          i {
            font-size: 2em;
            color: #ff7643;
            margin-left: 10px;
          }

          .time-info {
            margin-top: -4px;
          }

          span, a {
            font-size: 14px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 0.5;
            letter-spacing: normal;
            color: white;
            margin-left: 10px;
          }

          a {
            text-decoration: none;
            color: #ff7643;
          }

          .w3-col {
            width: 20%;
          }
        }

        .info-envio {
          margin-top: 40px !important;

          p {
            font-size: 18px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.33;
            letter-spacing: normal;
            color: white;
          }
        }
      }
    }

    &.w3-hide {
      display: none !important;
    }
  }

  .definition-wrapper.group {
    background-color: transparent;

    .labelText {
      color: #fff;
    }
  }

  .definitionObj.group .group-header {
    background-color: transparent !important;
  }

  .group.definitionObj.item.w3-col {
    position: static !important;
    left: 0 !important;
    top: 0 !important;

    .definition-wrapper.group {
      background-color: transparent !important;
    }
  }

  .item.group {
    position: static !important;
    left: 0 !important;
    top: 0 !important;

    .definition-wrapper.group {
      background-color: transparent !important;

      div.title {
        text-align: left !important;
      }
    }
    .definitionObj {
      padding-right: 10px;
    }
  }

  .mx-datepicker-main button {
    width: inherit;
  }

  #type_actions {
    position: relative;
    height: 100px;
    background-color: transparent;
    z-index: 0;

    .messages {
      width: 100%;
    }

    .buttons {
      width: 100%;

      button {
        margin-right: 10px;
        padding: 2px 20px 0;
        height: 40px;
        width: initial;
        border-radius: 0;

        &.delete {
          background-color: #ffec80;
          color: #333;
          text-transform: inherit;
        }

        span {
          font-size: 16px;
        }
      }

      .containerFormConfirmDelete {
        margin-right: 10px;

        button {
          width: 10%;
          border: 1px solid #555;
          background-color: #fff;
          padding: 2px 0 0;
          min-width: 100px;

          span {
            color: #000;
          }
        }

        .formConfirmDelete {
          display: none;
        }
      }
    }

    button.delete {
      background-color: #d42e12;
      span {
        color: inherit;
      }
    }
  }

  .tasks {
    .eval {
      .taskEval {
        background: none;
        span {
          font-weight: bolder;
          font-family: 'Noto Sans';
          font-size: 14px;
          padding-top: 4px;
        }
      }
    }
  }

  .pretty .state label {
    color: #fff;
  }

  .close_detail {
    top: 25px;
    right: 55px;
    color: #d42e12;
    cursor: pointer;
    z-index: 1000;

    i {
      font-size: 1.8em;
      transition: color 0.2s ease-in;

      &:hover {
        color: #999;
      }
    }
  }
}
.go_back {
  bottom: 11px;
  top: auto;
  left: 18px;
  color: #ff7643;
  cursor: pointer;
  z-index: 0;
  width: 17px;

  i {
    font-size: 33px;
    transition: color 0.2s ease-in;

    &:hover {
      color: #d42e12;
    }
  }
}
#type_actions {
  .normal-buttons {
    .buttons, .button {
      float: right;
    }
  }

  .pagination-sections {
    width: 100%;
    display: table;
    padding: 0 20px;

    .pagination-section {
      display: table-cell;
      text-align: left;
      font-size: 12px;
      padding: 0 5px;
      transition: all 0.2s ease-in;

      .pagination-top-separator {
        width: 100%;
        display: block;
        border-radius: 4px;
        margin-bottom: 5px;
        transition: all 0.2s ease-in;
      }

      &.current-pagination {
        .pagination-top-separator {
          border: 2px solid #4F4F4F;
          background-color: #4F4F4F;
        }
      }

      &.next-pagination {
        color: #E0E0E0;

        .pagination-top-separator {
          border: 2px solid #E0E0E0;
          background-color: #E0E0E0;
        }
      }

      &.past-pagination {
        color: #27A556;
        cursor: pointer;

        .pagination-top-separator {
          border: 2px solid #27A556;
          background-color: #27A556;
        }
      }

      .pagination-icon {
        display: inline-block;
        vertical-align: sub;
      }
    }
  }

  .carousel-buttons {
    margin-top: 30px;
    display: table;

    .button {
      display: table-cell;
      width: 18%;
      min-width: 150px;

      &.next {
        text-align: right;
      }

      button {
        padding: 0 15px;
        border: 0;
        cursor: pointer;
        opacity: 0.9;
        transition: all 0.1s ease-in;
        background-color: #FA252F;
        width: 100%;
        border-radius: 4px;
        max-width: 300px;

        span {
          font-size: 0.9em;
        }

        &:hover {
          opacity: 1;
        }

        &.disabled {
          cursor: default;
          opacity: 0.5;
        }
      }
    }

    .section-pagination {
      text-align: center;
      display: table-cell;
    }
  }

  .buttons {
    margin-top: 9px;
    background-color: transparent;
    border: 0;
  }

  button {
    padding:0 30px;
    height: 35px;
    background-color: #d42e12;
    transition: all 0.2s ease-in;
    outline: none !important;

    span {
      font-family: "Source Sans Pro", sans-serif;
      font-weight: 600;
      font-size: 20px;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;

      i {
        font-size: 16px;
        vertical-align: middle;
        margin-right: 3px;
      }
    }
  }

  .containerFormConfirmDelete {
    float: right;
    margin-right: 20px;

    span.formConfirmDelete {
      vertical-align: middle;
      padding:12px 20px;
      min-height: 50px;
      border-radius: 8px 0 0 8px;
      color: #000;
      font-size: 1.2em;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      float: right;

      i {
        vertical-align: sub;
      }
    }

    button.btnConfirmDelete {
      float: right;
      margin-right: 0 !important;
      margin-left: 20px;
      background-color: #d42e12;
      border-radius: 0;
      min-width: 120px;

      > div.no_spinner {
        padding-top:5px
      }

      i {
        font-size: 1.5em;
      }

      span {
        font-size: 1.2em;
        text-transform: uppercase;
        vertical-align: super;
      }

      i.icon-ico_ok, i.icon-ico_ok+span {
        color: #00bb00;
      }
      i.icon-ico_error, i.icon-ico_error+span {
        color: #cf0000;
      }
    }

    button.btnConfirmDelete:first-of-type {
      border-radius: 0 8px 8px 0;
    }
    button.btnConfirmDelete:hover {
      box-shadow: none;
    }
  }

  .save-and-out,
  .update-and-out,
  .delete {
    min-width: 200px
  }
  .save-and-stay,
  .update-and-stay {
    min-width: 200px
  }
  .delete {
    background-color: #edf118 !important;

    span {
      color: #000;
    }

    &:hover {
      span {
        color: #999;
      }
    }
  }
}
#appseg_segment_listgroup {
  #paginador {
    .download-button {
      position: fixed;
      bottom: 8px;
      left: 170px;
      margin: 0;
      padding: 10px;
      height: 45px;
      width: 45px;
      border-radius: 50%;
      background-color: #ff7643;
      float: left;
      outline: none !important;
      border: 0;
      cursor: pointer;

      i {
        font-size: 23px;
        width: 23px;
        color: #000;
        transition: all 0.2s ease-in;

        &:hover {
          color: #d42e12;
        }
      }
    }

    .downloading-results {
      position: fixed;
      bottom: 12px;
      left: 175px;
      margin: 0;

      .vue-simple-spinner {
        width: 35px !important;
        height: 35px !important;
      }
    }
  }
}
.mx-datepicker {
  width: 100% !important;
}
@media only screen and (max-width: 992px) {
  #sidebar-login {
    width: 100%;
    min-width: initial;
    padding: 0 5px;

    &.logged {
      display: none;
    }
  }
  #content>.app-container>.container-simplebar,
  .go_back {
    left: 18px !important;
  }
  #content #contenidor_appheader,
  .container_menu_detail,
  #type_actions .update-and-out,
  #type_actions .save-and-out,
  #detail>.w3-modal-content>.w3-container .container_detail>.container_inner_detail .close_detail {
    display: none;
  }
  .w3-modal-content {
    margin: 0 5px !important;
  }
  #detail {
    left: 0 !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
  }
  #sherpaCrmApp #type_actions {
    left: 0px !important;
    position: relative !important;
    margin-bottom: 60px;
  }
  #detail>.w3-modal-content>.w3-container .container_detail {
    margin-top: 5px;
  }
  #detail>.w3-modal-content>.w3-container [data-simplebar] {
    top: 0 !important;
  }
  #type_actions .buttons {
    width: 100%;
  }
  #sherpaCrmApp .definitionObj.group {
    padding: 0 !important;
  }
  .app-container #container_form_definition .definition-wrapper.group {
    border: 0 !important;
  }
  #detail>.w3-modal-content>.w3-container .container_detail {
    padding-bottom: 0 !important;
    margin-top: 5px !important;
  }
  .definition-wrapper .group-elements {
    padding: 0 5px !important;
  }
}
@media only screen and (min-width: 993px) {
  #sidebar-login {
    &.logged {
      width: 100px;
    }
  }
}
</style>
